import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { Image } from "antd";
import ImageComponent from "../../../utils/ImageComponent";

const ProductImage = ({ menuData }) => {
  const [activeImg, setActiveImg] = useState(0);
  const smallImagesContainerRef = useRef(null);
  const { small_images: smallImages_Url } = menuData;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 800);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleUpClick = () => {
    setActiveImg((prevIndex) => {
      const newIndex =
        prevIndex > 0 ? prevIndex - 1 : smallImages_Url.length - 1;
      scrollToImage(newIndex);
      return newIndex;
    });
  };

  const handleDownClick = () => {
    setActiveImg((prevIndex) => {
      const newIndex =
        prevIndex < smallImages_Url?.length - 1 ? prevIndex + 1 : 0;
      scrollToImage(newIndex);
      return newIndex;
    });
  };

  const scrollToImage = (index) => {
    const container = smallImagesContainerRef.current;
    const selectedImage = container.children[index];
    container.scrollTop = selectedImage.offsetTop - container.offsetTop;
  };

  return (
    <div
      className={`sm:sticky top-28 flex md:flex-row flex-col-reverse md:w-1/2 w-full gap-5 ${
        smallImages_Url?.length <= 3 ? "items-start" : "items-center"
      }  justify-center`}
    >
      {/* Small Image Section */}
      <div className="flex flex-row gap-3 items-center md:flex-col md:w-28">
        {/* Up Arrow */}
        {smallImages_Url?.length >= 4 && (
          <button
            onClick={handleUpClick}
            className="border border-mediumBlue p-1 rounded text-mediumBlue"
          >
            {isMobile ? (
              <FiChevronLeft size={20} />
            ) : (
              <IoIosArrowUp size={20} />
            )}
          </button>
        )}
        {/* Small Images Section */}
        <div
          ref={smallImagesContainerRef}
          className={`flex md:flex-col flex-row items-center w-full md:h-96 gap-3 overflow-hidden`}
        >
          {smallImages_Url?.length === 0 ? (
            <img
              src={menuData?.image}
              alt={menuData?.image + "image"}
              className={`w-20 h-20 object-cover border border-lightGray hover:border-mediumBlue duration-500 rounded p-1 `}
            />
          ) : (
            smallImages_Url?.map((url, id) => (
              <img
                key={id}
                src={url}
                alt={`Thumbnail ${id + 1}`}
                className={`md:w-20 sm:w-16 w-12 h-12 sm:h-16 md:h-20 object-cover border border-lightGray hover:border-mediumBlue duration-500 rounded p-1 ${
                  activeImg === id ? "border-mediumBlue" : "border-none"
                }`}
                onClick={() => {
                  setActiveImg(id);
                  scrollToImage(id);
                }}
              />
            ))
          )}
        </div>
        {/* Down Arrow */}
        {smallImages_Url?.length > 4 && (
          <button
            onClick={handleDownClick}
            className="border border-mediumBlue p-1 rounded text-mediumBlue"
          >
            {isMobile ? (
              <FiChevronRight size={20} />
            ) : (
              <IoIosArrowDown size={20} />
            )}
          </button>
        )}
      </div>

      <div className="flex items-center justify-center w-full">
        <ImageComponent
          // height={550}
          // width={600}
          styling={
            "object-cover md:h-[26rem] h-96 w-full md:max-w-full relative"
          }
          imageUrl={
            smallImages_Url?.length > 1
              ? smallImages_Url[activeImg]
              : menuData?.image
          }
          altText={`Product Image ${activeImg + 1}`}
        />
        {/* <Image
          // height={550}
          // width={600}
          className="object-cover md:max-h-[26rem] h-96 w-full md:max-w-96 relative"
          src={
            smallImages_Url?.length > 1
              ? smallImages_Url[activeImg]
              : menuData?.image
          }
          alt={`Product Image ${activeImg + 1}`}
        /> */}
      </div>
    </div>
  );
};

export default ProductImage;
